export default __webpack_public_path__ + "static/cleanneedlefile-b7340a8996f466b018cc88b6d4478588.png";